import React from 'react';

const GalleryImageIcon = ({ size = 20, color = "#55000C", strokeWidth = 1.25, className = "", ...props }) => (
  <svg 
    width={size} 
    height={size} 
    viewBox="0 0 20 20" 
    fill="none" 
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    {...props}
  >
    <path 
      d="M17.4385 8.325C11.9302 7.56833 7.18018 11.6583 7.49935 17.0833M5.41602 6.66667C5.41602 7.10869 5.59161 7.53262 5.90417 7.84518C6.21673 8.15774 6.64065 8.33333 7.08268 8.33333C7.52471 8.33333 7.94863 8.15774 8.26119 7.84518C8.57375 7.53262 8.74935 7.10869 8.74935 6.66667C8.74935 6.22464 8.57375 5.80072 8.26119 5.48816C7.94863 5.17559 7.52471 5 7.08268 5C6.64065 5 6.21673 5.17559 5.90417 5.48816C5.59161 5.80072 5.41602 6.22464 5.41602 6.66667Z" 
      stroke={color} 
      strokeWidth={strokeWidth} 
      strokeLinecap="round" 
      strokeLinejoin="round"
    />
    <path 
      d="M2.5 10.8887C4.81667 10.5679 6.89583 11.6871 8.02 13.4721" 
      stroke={color} 
      strokeWidth={strokeWidth} 
      strokeLinecap="round" 
      strokeLinejoin="round"
    />
    <path 
      d="M2.5 7.83333C2.5 5.96667 2.5 5.03333 2.86333 4.32C3.18291 3.69282 3.69282 3.18291 4.32 2.86333C5.03333 2.5 5.96667 2.5 7.83333 2.5H12.1667C14.0333 2.5 14.9667 2.5 15.68 2.86333C16.3072 3.18291 16.8171 3.69282 17.1367 4.32C17.5 5.03333 17.5 5.96667 17.5 7.83333V12.1667C17.5 14.0333 17.5 14.9667 17.1367 15.68C16.8171 16.3072 16.3072 16.8171 15.68 17.1367C14.9667 17.5 14.0333 17.5 12.1667 17.5H7.83333C5.96667 17.5 5.03333 17.5 4.32 17.1367C3.69282 16.8171 3.18291 16.3072 2.86333 15.68C2.5 14.9667 2.5 14.0333 2.5 12.1667V7.83333Z" 
      stroke={color} 
      strokeWidth={strokeWidth} 
      strokeLinecap="round" 
      strokeLinejoin="round"
    />
  </svg>
);

export default GalleryImageIcon;